import {
  useGetAssessmentsForOrganisationQuery,
  useGetPlacementTestsAndResultsForOrganisationQuery,
} from '@/app/redux/endpoints/assessments';
import { useCurrentOrganisationId } from '@/app/redux/hooks/organisation';
import { Assessment } from '@/common/types/assessment';
import { useMemo } from 'react';

export function useAssessments() {
  const { currentOrganisationId } = useCurrentOrganisationId();
  const skip = !currentOrganisationId;

  const {
    data: assessments = [],
    isLoading: assessmentsLoading,
    isFetching: assessmentsFetching,
    error: assessmentsError,
  } = useGetAssessmentsForOrganisationQuery(currentOrganisationId!, { skip });

  const {
    data: placementTestsData,
    isLoading: placementTestsLoading,
    isFetching: placementTestsFetching,
    error: placementTestsError,
  } = useGetPlacementTestsAndResultsForOrganisationQuery(
    currentOrganisationId!,
    { skip },
  );

  const assessmentsById = useMemo(() => {
    const byId = new Map<string, Assessment>();
    for (const a of assessments) byId.set(a.id, a);
    return byId;
  }, [assessments]);

  return {
    assessments,
    assessmentsById,
    placementTests: placementTestsData?.placementTests ?? [],
    placementTestResults: placementTestsData?.placementTestResults ?? [],
    isLoading: assessmentsLoading || placementTestsLoading,
    isFetching: assessmentsFetching || placementTestsFetching,
    error: assessmentsError ?? placementTestsError,
  };
}
